// src/components/Impressum.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const Impressum = () => {
  // Replace these placeholder values with your real information
  const owner = {
    name: "Dominik Ruf",
    street: "Am Maueranger 16",
    postal: "76228",
    city: "Karlsruhe",
    country: "Deutschland",
    responsiblePerson: "Dominik Ruf"
  };

  return (
    <div className="card shadow-sm">
      <div className="card-body">
        <h1 className="card-title">Impressum</h1>

        <section className="mb-3">
          <h5>Angaben gemäß § 5 TMG</h5>
          <p>
            {owner.name}<br />
            {owner.street}<br />
            {owner.postal} {owner.city}<br />
            {owner.country}
          </p>
        </section>

        <section className="mb-3">
          <h5>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h5>
          <p>{owner.responsiblePerson}</p>
        </section>

        <section className="mb-3">
          <h5>Haftungsausschluss</h5>
          <p>
            Die Inhalte dieser Website wurden mit größtmöglicher Sorgfalt erstellt. Für die Richtigkeit,
            Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.
          </p>
        </section>

        <section className="mb-3">
          <h5>Urheberrecht</h5>
          <p>
            Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht.
            Beiträge Dritter sind als solche gekennzeichnet. Jede Art der Vervielfältigung, Bearbeitung, Verbreitung
            und Verwertung außerhalb der Grenzen des Urheberrechtes bedarf der schriftlichen Zustimmung des jeweiligen Autors.
          </p>
        </section>

        <p className="text-muted small">
          Hinweis: Dies ist ein Muster-Impressum. Ersetzen Sie die Platzhalter durch Ihre tatsächlichen Daten und lassen
          Sie das Impressum bei Bedarf rechtlich prüfen.
        </p>

        <p>
          <Link to="/datenschutz">Zur Datenschutzerklärung</Link>
        </p>
      </div>
    </div>
  );
};

export default Impressum;
